import React, { useEffect, useRef, useState } from "react";
import styles from "./CleanerChecklist.module.css";
import { List, Modal } from "antd";
import { BsCheckCircle, BsEmojiWink } from "react-icons/bs";
import { AntdSubmit } from "../../components";
import {
  MdClear,
  MdOutlineSentimentDissatisfied,
  MdOutlineSentimentSatisfied,
  MdOutlineSentimentVeryDissatisfied,
  MdOutlineSentimentVerySatisfied,
  MdOutlineStopCircle,
  MdPlayCircleOutline,
} from "react-icons/md";
import before from "../../assets/workBefore.png";
import addImg from "../../assets/addImg.png";
import lunchImg from "../../assets/lunchImg.png";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import StartJobMiddleware from "../../store/Middlewares/StartJobMiddleware";
import moment from "moment";
import AlertAction from "../../store/Actions/AlertActions";
import { GoSmiley } from "react-icons/go";
import { GrEmoji } from "react-icons/gr";
import { BiSad } from "react-icons/bi";
import { IMG_URL } from "../../store/Apis";
const CleanerChecklist = () => {
  const location = useLocation();
  const navigate = useNavigate();

  console.log("location", location);
  const [current, setCurrent] = useState(0);
  const [selectedItem, setSelectedItem] = useState();
  const hiddenFileInput = React.useRef();
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const videoRef = useRef(null);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };
  const moodList = [
    {
      id: 1,
      icon: <MdOutlineSentimentDissatisfied />,
    },
    {
      id: 2,
      icon: <MdOutlineSentimentSatisfied />,
    },
    {
      id: 3,
      icon: <MdOutlineSentimentVeryDissatisfied />,
    },
    {
      id: 4,
      icon: <MdOutlineSentimentVerySatisfied />,
    },
  ];
  const options = [
    {
      id: 1,
      name: "Sweep Floors",
      description: "Mop",
      icon: true,
    },
    {
      id: 2,
      name: "Sweep Floors",
      description: "Mop",
      icon: false,
    },
  ];

  const dispatch = useDispatch();

  const Data = location?.state;
  const [CheckList, setCheckList] = useState([]);
  const [selectedCheckList, setselectedCheckList] = useState([]);
  console.log("Data", Data);
  const [Location, setLocation] = useState("8675, New York City");
  const [mediaType, setmediaType] = useState(null);
  const [LoginTime, setLoginTime] = useState(
    `Logged In Since ${Data?.startTime}`
  );
  const [Day, setDay] = useState(moment().format("ddd ,MMM D,YYYY")); //'Tue ,Sep 5,2022'
  const [Time, setTime] = useState(`${Data?.startTime}-${Data?.endTime}`);
  const [StartTime, setStartTime] = useState(Data?.startTime);
  const [StopTime, setStopTime] = useState(Data?.endTime);
  const [Reaction, setReaction] = useState([
    // { id: '1', emoji: 'emoji-flirt' },
    // { id: '2', emoji: 'emoji-happy' },
    // { id: '3', emoji: 'emoji-neutral' },
    // { id: '4', emoji: 'emoji-sad' },
    {
      id: 1,
      icon: <BsEmojiWink />,
    },
    {
      id: 2,
      icon: <GoSmiley />,
    },
    {
      id: 3,
      icon: <GrEmoji />,
    },
    {
      id: 4,
      icon: <BiSad />,
    },
  ]);
  const [pickImage, setpickImage] = useState();
  const [selectedReaction, setselectedReaction] = useState();
  const [AddNoteToggel, setAddNoteToggel] = useState(false);
  const [AddNote, setAddNote] = useState("");
  const [AddProblemReportToggel, setAddProblemReportToggel] = useState(false);
  const [AddProblemReport, setAddProblemReport] = useState("");
  const [ModalVisible, setModalVisible] = useState(false);
  const [AfterImage, setAfterImage] = useState();
  const [cords, setCords] = useState(null);

  useEffect(() => {
    getJobDetails();
    getLiveLocation();
  }, []);

  const getJobDetails = () => {
    let data = {
      job_id: Data?.job_id,
    };
    dispatch(StartJobMiddleware.getJobDetails(data))
      .then((data) => {
        let arraydata = [];
        for (let i = 0; i < data?.data?.checklist.length; i++) {
          arraydata.push({
            id: data?.data?.checklist[i]?.id,
            title: data?.data?.checklist[i]?.name,
            data: data?.data?.checklist[i]?.items,
          });
        }
        setCheckList(arraydata);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getLiveLocation = async () => {
    if (!navigator.geolocation) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Geolocation is not supported by your browser",
        })
      );
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          let getCords = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          setCords(getCords);
        },
        () => {
          dispatch(
            AlertAction.ShowAlert({
              type: "error",
              message:
                "Unable to retrieve your location . Please Enable your location.",
            })
          );
        }
      );
    }
  };

  const onSelectedCheckList = (id) => {
    let item = selectedCheckList.findIndex((val) => val == id);
    if (item > -1) {
      let array_copy = [...selectedCheckList];
      array_copy.splice(item, 1);
      setselectedCheckList(array_copy);
    } else {
      let array_copy = [...selectedCheckList];
      array_copy.push(id);
      setselectedCheckList(array_copy);
    }
  };

  const handleSubmit = () => {
    if (!pickImage) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Please Select After Picture",
        })
      );
      // Alert.alert('Please Select After Picture');
      return;
    } else if (!selectedReaction) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Please Select Mood Rating",
        })
      );
      // Alert.alert('Please Select Mood Rating');
      return;
    } else {
      let userData = {
        job_id: Data?.job_id,
        rating: selectedReaction,
        note: AddNote,
        problem: AddProblemReport,
        latitude: cords?.latitude,
        longitude: cords?.longitude,
        // mediaType: mediaType,
        pickImage: pickImage,
        checklist: selectedCheckList,
      };

      dispatch(StartJobMiddleware.completeJob(userData))
        .then((data) => {
          dispatch(
            AlertAction.ShowAlert({ type: "success", message: data?.message })
          );
          navigate("/");
          // Alert.alert('Note', data?.message, [
          //     { text: 'OK', onPress: () => navigation.navigate('EmployeeBottomTabs') },
          // ]);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const renderItem = (item) => {
    console.log("item", item);

    return (
      <div className={styles.listItem}>
        <div className={styles.listHeader}>
          <p>{item?.title}</p>
        </div>
        {item?.data?.map((item, index) => {
          let checked = selectedCheckList.includes(item?.id);
          return (
            <div
              onClick={() => onSelectedCheckList(item?.id)}
              style={{
                border: "1px solid var(--secondary-color)",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                padding: "2%",
                margin: "2% 0%",
              }}
            >
              <div>
                {/* <text>{index + 1 + " ) "}</text>
                <text>Name</text> */}
                <p>{item?.name}</p>
                <text>Description</text>
                <p>{item?.description}</p>
              </div>
              <div>
                <BsCheckCircle
                  color={checked ? "56F71E" : "F44336"}
                  size={25}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.subDiv}>
        {current == "0" ? (
          <div className={styles.heading}>
            <h1>Checklist</h1>
            <h2>Lobby:</h2>
            <List
              className={styles.list}
              style={{ width: "100%" }}
              //   grid={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 2, xxl: 2 }}
              dataSource={CheckList}
              renderItem={renderItem}
            />
            <div className={styles.btn} onClick={() => next()}>
              <AntdSubmit
                text={"Next"}
                buttonStyle={{
                  margin: "15px 0px",
                  height: "60px",
                  width: "100%",
                }}
              />
            </div>
          </div>
        ) : current == "1" ? (
          <div className={styles.heading}>
            <h1>Complete Job</h1>
            <h2>{LoginTime}</h2>
            <h3>
              {Day} , {Time}
            </h3>
            <div className={styles.timer}>
              <div className={styles.subTimer}>
                <MdPlayCircleOutline className={styles.playIcon} />
                <div className={styles.txt}>
                  <h1>{StartTime}</h1>
                  <p>Start</p>
                </div>
              </div>
              <div className={styles.subTimer}>
                <MdOutlineStopCircle className={styles.playIcon} />
                <div className={styles.txt}>
                  <h1>{StopTime}</h1>
                  <p>Finish</p>
                </div>
              </div>
            </div>
            <h5>Picture (Before and After work)</h5>
            <div className={styles.images}>
              <div className={styles.imageDiv}>
                {Data?.beforeImage?.type?.match("video/*") || Data?.beforeImage?.type == "video" ?
                  <video style={{width:'100%'}} controls src={URL.createObjectURL(Data?.beforeImage)} ></video>
                  :
                  <img
                    src={
                      Data?.beforeImage
                        ? URL.createObjectURL(Data?.beforeImage)
                        : before
                    }
                  />
                }
                <p>Before</p>
              </div>
              <div
                className={styles.imageDiv}
                onClick={showModal}
                style={{ cursor: "pointer" }}
              >
                {/* <img src={addImg} /> */}
                {pickImage?.type?.match("video/*") ?
                  <video style={{width:'100%'}} controls src={URL.createObjectURL(pickImage)} ></video> :
                  <img
                    src={AfterImage ? URL.createObjectURL(AfterImage) : addImg}
                  />}
                <p>After</p>
              </div>
            </div>
            <h5>Lunch Break</h5>
            {Data?.afterLunch !== null ? (
              <div className={styles.lunchImg}>
                <img src={URL.createObjectURL(Data?.afterLunch)} />
              </div>
            ) : (
              
              <h3>No Attachment found.</h3>
            )}
            <div className={styles.moodReporting}>
              <span>Mood Reporting</span>
              <p>How's Your Feeling After The Cleaning Service</p>
              <div className={styles.emoji}>
                {Reaction?.map((item) => {
                  return (
                    <div
                      onClick={() => setselectedReaction(item?.id)}
                      className={
                        selectedReaction == item?.id
                          ? styles.selectedICon
                          : styles.unSelectedIcon
                      }
                      style={{
                        width: "30px",
                        height: "30px",
                        fontSize: "30px",
                        marginRight: "50px",
                        cursor: "pointer",
                      }}
                    >
                      {item?.icon}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={styles.input}>
              <label>Add Note</label>
              <textarea placeholder="Type Note Here" type="text" rows={3} onChange={(e) => setAddNote(e.target.value)} />
            </div>

            <div className={styles.repInput}>
              <label>Add Problem Report</label>
              <textarea placeholder="Type Problem Report Here" type="text" rows={3} onChange={(e) => setAddProblemReport(e.target.value)} />
            </div>
            <div className={styles.btn}>
              <AntdSubmit
                onClick={() => handleSubmit()}
                text={"Complete Job"}
                buttonStyle={{
                  margin: "15px 0px",
                  height: "60px",
                  width: "100%",
                }}
              />
            </div>
          </div>
        ) : null}
      </div>
      <Modal
        className="modalStyle"
        style={{
          border: "2px solid #f6921e",
          backgroundColor: "#0F0F0F",
          borderRadius: "10px",
        }}
        closable={false}
        footer={null}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      // width={700}
      >
        <div style={{ display: "flex", justifyContent: "right" }}>
          <MdClear
            style={{ cursor: "pointer" }}
            color="#f6921e"
            size={25}
            onClick={handleCancel}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.modalHead}>
            <h1>Please Upload A Photo / Video</h1>
            <p>Before Start Task</p>
          </div>
          <div className={styles.modalImg}>
            {pickImage?.type?.match("video/*") ?

              <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <video style={{ width: '100%' }} ref={videoRef} onBlur={() => videoRef.current.pause()} controls src={pickImage ? URL.createObjectURL(pickImage) : addImg} onClick={() => handleClick()} ></video>
              </div>
              // <iframe  onClick={() => handleClick()} ></iframe>
              :
              <img
                src={pickImage ? URL.createObjectURL(pickImage) : addImg}
                onClick={() => handleClick()}
              />
            }
          </div>
          <input
            type="file"
            accept="image/* , video/*"
            onChange={(e) => {
              setpickImage(e.target.files[0]);
              setAfterImage(e.target.files[0]);
            }}
            ref={hiddenFileInput}
            style={{ display: "none" }}
          />
          <div className={styles.modalBtns}>
            <AntdSubmit
              onClick={handleOk}
              text={"Upload"}
              buttonStyle={{
                margin: "15px 0px",
                height: "60px",
                width: "100%",
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CleanerChecklist;
